<template>
  <div class="aco-grid">
    <div class="aco-info-box">
      <b-card>
        <margin-fields :fields="marginFields()"/>
      </b-card>
    </div>

    <div>
      <div class="aco-details-box">
        <b-col class="aco-details">
          <details-form :fields="detailsFields()" :state-object="group"/>
        </b-col>
      </div>
      <div class="aco-details-box">
        <b-col class="aco-details">
          <b-row>
            <b-col>
              <h5>{{ $t('groupMembers') }}</h5>
            </b-col>
          </b-row>
          <template>
            <b-table show-empty striped hover small class="aco-table" :items="members" :fields="groupMemberFields()">
              <template slot="empty">
                <div class="text-center">{{ $t('noResults')}}</div>
              </template>
              <template v-slot:cell(to_user)="row">
                <router-link :to="{ name: 'UserDetails', params: { id: row.item.userId }}">
                  <b-button size="sm" class="py-0">{{$t('user') }}</b-button>
                </router-link>
              </template>
            </b-table>
          </template>
        </b-col>
      </div>
    </div>
  </div>
</template>

<script>
  import BaseComponent from '../../components/BaseComponent'
  import { mapGetters } from 'vuex'
  import MarginFields from '../../components/MarginFields'
  import DetailsForm from '../../components/DetailsForm'

  export default {
    name: 'GroupDetails',
    extends: BaseComponent,
    components: {
      'marginFields': MarginFields,
      'detailsForm': DetailsForm
    },
    computed: {
      ...mapGetters('groups', ['group', 'members'])
    },
    created () {
      this.$store.dispatch('groups/getGroupByGroupId', this.$route.params.id)
      this.$store.dispatch('groups/getGroupMembers', this.$route.params.id)
    },
    methods: {
      marginFields () {
        return [
          { name: 'groupSource', displayName: this.$t('source'), value: this.translateAlternatives('groupSources', this.group.groupSource) },
          { name: 'groupType', displayName: this.$t('type'), value: this.translateAlternatives('groupTypes', this.group.groupType) },
          { name: 'startDate', displayName: this.$t('startDate'), value: this.formatTimestamp(this.group.startDate)},
          { name: 'endDate', displayName: this.$t('endDate'), value: this.formatTimestamp(this.group.endDate) }
        ]
      },
      detailsFields () {
        return [
          { type: 'header', backButton: true, width: 12, displayName: this.$t('groupInformation') },
          { type: 'text', name: 'name', readonly: true, width: 4, displayName: this.$t('name') },
          { type: 'text', name: 'ownerOrganizationNumber', readonly: true, width: 4, displayName: this.$t('organization') },
          { type: 'text', name: 'grepCode', readonly: true, width: 4, displayName: this.$t('grepFagkode') }
        ]
      },
      groupMemberFields () {
        return [
          { key: 'fullName', label: this.$t('fullName'), tdClass: 'text-nowrap' },
          { key: 'firstName', label: this.$t('firstName'), tdClass: 'text-nowrap' },
          { key: 'lastName', label: this.$t('lastName'), tdClass: 'text-nowrap' },
          { key: 'role', label: this.$t('role'), tdClass: 'text-nowrap', formatter: value => this.translateAlternatives('userPrimaryRoles', value) },
          { key: 'groupRole', label: this.$t('groupRole'), tdClass: 'text-nowrap', formatter: value => this.translateAlternatives('groupRoles', value) },
          { key: 'to_user', label: '' }
        ]
      }
    }
  }
</script>
